(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/impleo-widget-definition.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/impleo-widget-definition.js');
"use strict";


const KambiWidgetDefinition = svs.oddset_kambi.components.kambiWidgetUtils.definitions.KambiWidgetDefinition;
const {
  WIDGET_ID,
  WIDGET_TAG
} = svs.oddset_kambi.components.kambiWidgetUtils.constants;
class ImpleoWidgetDefinition extends KambiWidgetDefinition {
  constructor() {
    super(WIDGET_ID.impleoWidget, WIDGET_TAG.impleoWidget, {
      eventColumn2Placeholder2: [{
        widgetId: WIDGET_ID.impleoWidget,
        order: 1,
        filter: 'ishockey/sverige'
      }]
    });
  }
}
setGlobal('svs.oddset_kambi.components.kambiWidgetUtils.definitions.ImpleoWidgetDefinition', ImpleoWidgetDefinition);

 })(window);